import { pagesUrl, hotelPanelRootUrl } from "../../../common/utils/panel-helpers/helpers";

// method for checking if user lands on login directly and if it has access token
export const isUserLandsOnLogin = (accessToken: string): boolean => {
  const loginPath = `/${hotelPanelRootUrl}/${pagesUrl.login}`;

  return !!(window.location.pathname === loginPath && accessToken);
};
